/**
 * ma-crossover-page.js
 *
 * MA Crossover strategy (strategies/macrossover.md) — across Weekly, Daily, 4H:
 *   3 or more of SMA 15, 50, 100 and 200 involved in crosses within 4 candles
 *   of each other, all in the same direction — the averages have converged back to
 *   their mean, so a larger move is likely to follow.
 *   Long:  faster SMAs crossing above slower ones
 *   Short: faster SMAs crossing below slower ones
 * Detection lives in server/indicator-engine.js → computeMaCrossover().
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchMaCrossoverData } from '../services/server-api';

const TF_LABELS = { weekly: 'Weekly', daily: 'Daily', fourHour: '4H' };

function fmt(v) {
  return v != null ? `$${v.toLocaleString(undefined, { maximumFractionDigits: 6 })}` : '—';
}

function agoLabel(barsAgo) {
  if (barsAgo === 0) return 'last candle';
  return `${barsAgo} candle${barsAgo === 1 ? '' : 's'} ago`;
}

function renderDetails(entry) {
  const isLong = entry.state === 'long';
  const cls    = isLong ? 'bull' : 'bear';
  return (
    <>
      {(entry.crosses || []).map(c => (
        <div className="mtf-ind-row" key={`${c.fast}-${c.slow}`}>
          <span className="mtf-ind-label">SMA {c.fast} {isLong ? '↑ above' : '↓ below'} {c.slow}</span>
          <span className={`mtf-ind-value ${cls}`}>{agoLabel(c.barsAgo)}</span>
        </div>
      ))}
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">SMA 15 / 50</span>
        <span className="mtf-ind-value">{fmt(entry.sma15)} / {fmt(entry.sma50)}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">SMA 100 / 200</span>
        <span className="mtf-ind-value">{fmt(entry.sma100)} / {fmt(entry.sma200)}</span>
      </div>
    </>
  );
}

function MaCrossoverPage() {
  return (
    <StrategySignalsPage
      config={{
        title:      'MA Crossover',
        icon:       '🔀',
        subtitle:   '3 or more of SMA 15, 50, 100 and 200 crossing within 4 candles of each other, all in the same direction',
        fetchFn:    fetchMaCrossoverData,
        timeframes: ['weekly', 'daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default MaCrossoverPage;
